import React, {Component} from 'react'
import DocumentTitle from 'react-document-title'
import Cta from '../Cta'

import {posts} from './posts'

import style from './style.sass'

class BlogDetails extends Component {
  render() {
    const {index} = this.props.match.params
    return(
      <div>
        <DocumentTitle title='Blog'/>
        <div styleName='banner' />
        <section className='bg-white'>
          <div className='landing-container' styleName='container'>
            <h1 styleName='post-detail-heaher'>{posts[index].title}</h1>
            <div styleName='post-description'>
              <p styleName='author-name-l'>{posts[index].author}</p>
              <p styleName='post-date'>{posts[index].at}</p>
            </div>
            <div>
              <img src={posts[index].img} styleName='blog-image' />
            </div>
            {posts[index].content}
          </div>
        </section>
        <Cta/>
      </div>
    )
  }
}

export default BlogDetails
